import React from 'react'
import styles from './Billing.module.css'

import PropTypes from 'prop-types'


import {
  TextField,
  Button,
  MenuItem,
  Grid
} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'

class BillingSearch extends React.Component {
	render() {
		return (
			<div>
				<Grid container spacing={1}>
          <Grid item xs={6} lg={2}>
            <TextField
              autoComplete="off"
              className={styles.textFields}
              type="date"
              variant="outlined"
              size="small"
              name="due_at_from"
              fullWidth={true}
              label="Due at From  "
              onChange={this.props.handleChange}
              onKeyPress={this.props.handleKeyPress}
              value={this.props.item.due_at_from}
              id="payee-date_of_check_from"
              InputLabelProps={{
                shrink: true
              }}
            />
					</Grid>
					<Grid item xs={6} lg={2}>
            <TextField
              autoComplete="off"
              className={styles.textFields}
              type="date"
              variant="outlined"
              size="small"
              name="due_at_to"
              fullWidth={true}
              label="Due at To"
              onChange={this.props.handleChange}
              onKeyPress={this.props.handleKeyPress}
              value={this.props.item.due_at_to}
              InputLabelProps={{
                shrink: true
              }}
            />
					</Grid>
					<Grid item xs={6} lg={3}>
						<TextField
							autoComplete="off"
							className={styles.textFields}
							variant="outlined"
							size="small"
							name="reference_no"
							fullWidth={true}
							label="Reference Number"
							onChange={this.props.handleChange}
							onKeyPress={this.props.handleKeyPress}
							value={this.props.item.reference_no}
							id="payee-tin"
						/>
					</Grid>
         
          <Grid item xs={6} lg={3}>
          <Autocomplete
                name="expense_type"
                id="expense_type"
                className={styles.textFields}
                size="small"
                options={this.props.expenseTypes}
                getOptionLabel={(option) => option.name }
                getOptionSelected={(option, value) => option.name === value.name}
                onChange={this.props.handleAutocompleteSearch}
                fullWidth="true"
                value={this.props.item.expense_type || {}}
                renderInput={(params) => <TextField {...params} label="Expense Type" variant="outlined" />}
              />
          </Grid>
          <Grid item xs={6} lg={2}>
            <TextField
              autoComplete="off"
              select
              className={styles.textFields}
              variant="outlined"
              size="small"
              name="status"
              fullWidth={true}
              label="Status"
              onChange={this.props.handleChange}
              value={this.props.item.status || ''}
              id="payee-classification"
              >
            <MenuItem value="" >&nbsp;</MenuItem>
            <MenuItem value="Posted">Posted</MenuItem>
            <MenuItem value="Not Posted">Not Posted</MenuItem>
            <MenuItem value="Cancelled">Cancelled</MenuItem>
          </TextField>
          </Grid>
          <Grid item xs={6} lg={3}>
            <div className={styles.textFields}>
              <Autocomplete
                name="payee"
                id="payee"
                size="small"
                options={this.props.payees}
                getOptionLabel={(option) => option.name}
                getOptionSelected={(option, value) => option.name === value.name}
                onChange={this.props.handleAutocompleteSearch}
                fullWidth="true"
                value={this.props.item.payee  || ''}
                renderInput={(params) => <TextField {...params} label="Payee" variant="outlined" />}
              />
            </div>
          </Grid>
          <Grid item xs={6} lg={3}>
            <div className={styles.textFields}>
              <Autocomplete
                name="branch"
                id="branch"
                size="small"
                options={this.props.branches}
                getOptionLabel={(option) => option.name}
                getOptionSelected={(option, value) => option.name === value.name}
                onChange={this.props.handleAutocompleteSearch}
                fullWidth="true"
                value={this.props.item.branch || {}}
                renderInput={(params) => <TextField {...params} label="Branch" variant="outlined" />}
              />
            </div>
          </Grid>
          <Grid item xs={6} lg={2}>
          <TextField
              autoComplete="off"
              select
              className={styles.textFields}
              variant="outlined"
              size="small"
              name="is_paid"
              fullWidth={true}
              label="Paid Status"
              onChange={this.props.handleChange}
              value={this.props.item.is_paid || ''}
              id="paid-status"
              InputLabelProps={{
                shrink: true
              }}
              >
            <MenuItem value="" >&nbsp;</MenuItem>
            <MenuItem value="true">Paid</MenuItem>
            <MenuItem value="false">Not yet paid</MenuItem>
          </TextField>
          </Grid>
          <Grid item xs={6} lg={2}>
          <TextField
              autoComplete="off"
              select
              className={styles.textFields}
              variant="outlined"
              size="small"
              name="taxable"
              fullWidth={true}
              label="Taxable"
              onChange={this.props.handleChange}
              value={this.props.item.taxable || ''}
              id="paid-status"
              >
            <MenuItem value="" >&nbsp;</MenuItem>
            <MenuItem value="true">Yes</MenuItem>
            <MenuItem value="false">No</MenuItem>
          </TextField>
          </Grid>
          <Grid item xs={6} lg={2}>
            <TextField
              autoComplete="off"
              className={styles.textFields}
              variant="outlined"
              size="small"
              name="remarks"
              fullWidth={true}
              label="Particulars"
              onChange={this.props.handleChange}
              onKeyPress={this.props.handleKeyPress}
              value={this.props.item.remarks}
            />
          </Grid>
				</Grid>
				<div className={styles.actionButton}>
					<Button variant="outlined" id="payee-clearSearch" color="secondary" onClick={() => this.props.clearSearch()} >Clear</Button>
          <Button variant="outlined" id="payee-search" color="primary" onClick={() => this.props.search()} >Search</Button>
				</div>

			</div>
		)
	}
}
export default BillingSearch

BillingSearch.propTypes = {
  handleChange: PropTypes.func,
  handleAutocompleteSearch: PropTypes.func,
	item: PropTypes.object,
  payees: PropTypes.array,
	search: PropTypes.func,
	clearSearch: PropTypes.func,
	handleKeyPress: PropTypes.func,
  expenseTypes: PropTypes.array,
  branches: PropTypes.array,
}
